import ParkingMarker from './ParkingMarker';

export default ParkingMarker;
